import React from "react";
import {
    Table,
    TableBody,
    TableRow,
    Typography,
} from "@mui/material";
import {
    StyledContentTableCell,
    StyledContentTableHeader,
} from "../StyledComponents";
import {Locale} from "../../../locales/Locale";
import {IMotorcycleDetailsConfig} from "../details/motorcycleDetailsConfig";
import {TwoWheeler} from "@mui/icons-material";
import {MotorcycleTableRow} from "../list/MotorcycleTableRow";

interface MotorcycleTableProps {
    motorcycles: any[];
    onRemoveMotorcycle: (id: number) => void;
    motorcycleDetailsConfig: IMotorcycleDetailsConfig[];
}

export const MotorcycleCompareTable: React.FC<MotorcycleTableProps> = ({
    motorcycles,
    onRemoveMotorcycle,
    motorcycleDetailsConfig,
}) => {

    return (
        <Table sx={{
            marginTop: "10px",
            borderCollapse: "separate",
            borderSpacing: "2px",
            width: "100%",
        }}>
            <TableBody>
                <TableRow>
                    <StyledContentTableHeader>
                        <TwoWheeler
                            fontSize="large"
                            sx={{
                                fontSize: { xs: "2rem", sm: "3rem" },
                                width: "100%"
                            }}
                        />
                    </StyledContentTableHeader>
                    {motorcycles.map((motorcycle) => (
                        <MotorcycleTableRow key={motorcycle.id} motorcycle={motorcycle} onRemove={onRemoveMotorcycle}/>
                    ))}
                </TableRow>
                {motorcycleDetailsConfig.map(({
                    param,
                    locaId,
                    renderer,
                }) => (
                    <TableRow key={locaId}>
                        <StyledContentTableHeader>
                            <Typography variant="caption" sx={{fontWeight: 500}}>
                                <Locale localeId={locaId}/>
                            </Typography>
                        </StyledContentTableHeader>
                        {motorcycles.map((motorcycle) => {
                            const value = motorcycle[param];
                            return (
                                <StyledContentTableCell key={motorcycle.id}>
                                    {renderer ? renderer({value}) :
                                        <Typography variant="body2">{value ?? "N/A"}</Typography>}
                                </StyledContentTableCell>
                            );
                        })}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};
